module.exports = __webpack_public_path__ + "img/1.10c7016e.png";